import Talent_Entity from "./talent";
export default class Talent extends Talent_Entity {
  static fromList(talentsJSON: unknown): Array<Talent> {
    const talents: Talent[] = [];
    if (talentsJSON)
      Array.isArray(talentsJSON) &&
        talentsJSON.forEach((talentJSON) => {
          talents.push(new Talent(talentJSON));
        });
    return talents;
  }

  initials() {
    let ret = "";
    if (this.firstName) ret += this.firstName[0];
    if (this.lastName) ret += this.lastName[0];
    return ret;
  }

  formattedAddress() {
    return `${this.address ?? ""}\n${this.city ?? ""} ${this.state ?? ""} ${
      this.zipcode ?? ""
    }`;
  }

  fullName() {
    return `${this.firstName ?? ""} ${this.lastName ?? ""}`;
  }

  validAddress() {
    const hasAddress = this.address?.length > 0;
    const hasZipcode = this.zipcode?.length > 0;
    const hasCity = this.city?.length > 0;
    const hasState = this.state?.length > 0;

    return hasAddress && hasZipcode && hasCity && hasState;
  }

  toJson(): string {
    return JSON.stringify(this);
  }
}
